import { useEffect, useRef, useState } from "react";
import { getDatabase, ref, onValue } from "firebase/database";

export default function NotificationListener({ onNewNotification }) {
  const lastNotificationKey = useRef(null);
  const [canPlaySound, setCanPlaySound] = useState(false);

  useEffect(() => {
    const enableSound = () => setCanPlaySound(true);
    window.addEventListener("click", enableSound, { once: true });
    window.addEventListener("keydown", enableSound, { once: true });
    return () => {
      window.removeEventListener("click", enableSound);
      window.removeEventListener("keydown", enableSound);
    };
  }, []);

  useEffect(() => {
    const user = JSON.parse(localStorage.getItem("user") || "{}");
    if (!user.id && !user.userId) return;
    const userId = user.id || user.userId;
    const db = getDatabase();
    const notificationsRef = ref(db, `notifications/${userId}`);

    const unsubscribe = onValue(notificationsRef, (snapshot) => {
      const data = snapshot.val() || {};
      const list = Object.entries(data)
        .map(([key, value]) => ({ ...value, id: key }))
        .sort((a, b) => (new Date(b.timestamp).getTime() - new Date(a.timestamp).getTime()));

      if (list.length > 0) {
        const latest = list[0];
        const latestKey = latest.id + (latest.timestamp || "");
        if (latestKey !== lastNotificationKey.current) {
          lastNotificationKey.current = latestKey;
          if (canPlaySound) {
            try {
              const audio = new Audio(process.env.PUBLIC_URL + "/message-ringtone-magic.mp3");
              audio.play();
              console.log("Playing notification sound");
            } catch (err) {
              console.log("Audio error:", err);
            }
          }
          if (onNewNotification) {
            onNewNotification(latest);
          }
        }
      }
    });

    return () => unsubscribe();
  }, [onNewNotification, canPlaySound]);

  return null;
}